import { PaperPreviewSectionsModel } from "./paper-preview-sections.model";
import { QnoToSerialNoMap } from "./qno-to-serial-no-map";

export class PaperPreviewModel {
    className: string;
    subject: string;
    noOfSections: number;
    marks: number;
    totalQuestions: number;
    timeLimit: number;
    tagline: string;
    partName: string;
    language: string;
    instructions: string;
    sections: PaperPreviewSectionsModel[];
    qnosOrder: QnoToSerialNoMap[];

    constructor(
        className: string,
        subject: string,
        noOfSections: number,
        marks: number,
        totalQuestions: number,
        timeLimit: number,
        tagline: string,
        partName: string,
        language: string,
        instructions: string,
        sections: PaperPreviewSectionsModel[],
        qnosOrder: QnoToSerialNoMap[]
    ) {
        this.className = className;
        this.subject = subject;
        this.noOfSections = noOfSections;
        this.marks = marks;
        this.totalQuestions = totalQuestions;
        this.timeLimit = timeLimit;
        this.tagline = tagline;
        this.partName = partName;
        this.language = language;
        this.instructions = instructions;
        this.sections = sections;
        this.qnosOrder = qnosOrder;
    }

}